import mutations from '@/store/lib/mutations'

export default {
  ...mutations
}
